import axios from "../../../../utils/request"

function GET_LIST(params) {
    return  axios.post("/detect/MAdRegisterRecordFacebook/index",{...params} )
}

function EXPORT(params) {
    return  axios.post("/detect/MAdRegisterRecordFacebook/export",{...params} )
}
export default {
    GET_LIST,
    EXPORT
}
